import "./web-call.js";
import "./iridescence.js";
import { CdialWidget } from "./widget.js";

if (typeof window !== "undefined" && typeof document !== "undefined") {
  const indigeniusElement = document.querySelector("indigenius-convai");
  const agentId = indigeniusElement?.getAttribute("agent-id");
  if (indigeniusElement) {
    if (agentId) {
      const sdk = new CdialWidget({ agentId, mountUI: true });
      sdk.init();
      console.log("init");
      window.CdialWidget = sdk;
    } else {
      console.error(
        "agent-id attribute is required for indigenius-convai element."
      );
    }
  } else {
    // console.error(
    //   "indigenius-convai element is required to initialize the HTML SDK."
    // );
  }
}

export { CdialWidget };
